var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClub(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4662 7.65936C16.6579 7.08095 16.7546 6.47747 16.7546 5.85648C16.7546 2.68339 14.1731 0.101854 11 0.101854C7.82691 0.101854 5.24537 2.68339 5.24537 5.85648C5.24537 6.47747 5.34213 7.08095 5.53381 7.65936C2.46268 7.77588 0 10.3107 0 13.4098C0 16.5829 2.58154 19.1644 5.75463 19.1644C7.22537 19.1644 8.56869 18.6094 9.58711 17.6982L8.34798 21.8981H13.6171L12.365 17.6545C13.389 18.5914 14.7514 19.1644 16.2454 19.1644C19.4185 19.1644 22 16.5829 22 13.4098C22 10.3107 19.5373 7.77588 16.4662 7.65936Z",
    fill: "#443C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClub);
export default __webpack_public_path__ + "static/media/club.3bdba8ff.svg";
export { ForwardRef as ReactComponent };